import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { GridLegacy } from "@mui/material";
import FormTextTC from "../../../components/Forms/FormTextTC";

function Informatie() {
  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <GridLegacy container spacing={1}>
            <FormTextTC
              name={"bigDescr"}
              rows={10}
              tDefault={"Omschrijving"}
              tKey={"producten.form.informatie.label.bigDescr"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Informatie;
